import { useAtomValue } from 'jotai'
import React from 'react'

import { AmplitudeProvider } from '~/components/providers/AmplitudeEventProvider'

import { isPercentageAtom } from '../../atoms'
import { useCustomerAttributeGroupsData } from '../../hooks/useCustomerAttributeGroupsData'
import { type SurveyGroupCustomerAttributeGroup } from '../../hooks/useMainQuery'
import { useVisibleSurveys } from '../../hooks/useVisibleSurveys'
import { getDatum } from '../../utils'

import { HeadingContainer } from './HeadingContainer'
import { TimeSeriesContent } from './TimeSeriesContent'

export type CustomerAttributeGroupContentProps = {
  customerAttributeGroup: SurveyGroupCustomerAttributeGroup
}

export const CustomerAttributeGroupContent = ({
  customerAttributeGroup,
}: CustomerAttributeGroupContentProps) => {
  const isPercentage = useAtomValue(isPercentageAtom)

  const surveys = useVisibleSurveys()
  const customerAttributeGroupsData = useCustomerAttributeGroupsData()
  const series = React.useMemo(
    () =>
      customerAttributeGroup.customerAttributes.map((customerAttribute) => ({
        data: surveys.map((survey) =>
          getDatum(
            customerAttributeGroupsData,
            (item) =>
              item.customerAttributeGroupId === customerAttributeGroup.id &&
              item.idLike === customerAttribute.idLike &&
              item.surveyId === survey.id,
            isPercentage,
          ),
        ),
        name: customerAttribute.name,
        isLabelVisible: true,
      })),
    [
      customerAttributeGroup.customerAttributes,
      customerAttributeGroup.id,
      customerAttributeGroupsData,
      isPercentage,
      surveys,
    ],
  )

  return (
    <AmplitudeProvider eventNameSuffix="_customized KPI">
      <HeadingContainer
        indicator={customerAttributeGroup.id}
        label={customerAttributeGroup.name}
      >
        <TimeSeriesContent series={series} />
      </HeadingContainer>
    </AmplitudeProvider>
  )
}
